module.exports = __webpack_public_path__ + "47fab06734815a28380afea6e703a986.png"


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/shop/soundway-hat.png
 ** module id = 487
 ** module chunks = 0
 **/